import { type PaginationState } from "@kazaar-platform/design-system";
import { useAtomValue } from "jotai";
import { useState } from "react";
import { type CustomSortingState } from "@/helpers/tables";
import { useGetNewRequests } from "@/hooks";
import { currentWorkspaceAtom } from "@/store";

export const useNewRequests = () => {
  const currentWorkspace = useAtomValue(currentWorkspaceAtom);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 1,
    pageSize: 10,
  });
  const [sorting, setSorting] = useState<CustomSortingState | undefined>(
    undefined
  );

  const { data: newRequestsData, isLoading } = useGetNewRequests({
    limit: pagination.pageSize,
    offset: (pagination.pageIndex - 1) * pagination.pageSize,
  });

  return {
    newRequests: newRequestsData?.data?.page || [],
    totalRows: newRequestsData?.data?.total || 0,
    serviceName: currentWorkspace?.name || "",
    isLoading,
    pagination,
    sorting,
    setPagination,
    setSorting,
    isModalOpen,
    setIsModalOpen,
  };
};
